import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn
} from '@angular/forms';

import { I18NextModule } from 'angular-i18next';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { AuthorizerUsers, User } from 'src/app/shared/model/user.model';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { LoanOptions } from 'src/app/shared/model/loanRequest.enum';
import { AdditionalInfoPetitionerComponent } from '../../../additional-info-petitioner/additional-info-petitioner.component';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { StorageService } from 'src/app/core/storage/storage.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackModalComponent } from '../../../feedback-modal/feedback-modal.component';
import i18next from 'i18next';
import { DeliveryLocation } from 'src/app/shared/model/location.enum';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import { CheckValidations } from 'src/app/shared/utils/checkValidations';

@Component({
  standalone: true,
  selector: 'app-step-additional-info',
  templateUrl: './step-additional-info.component.html',
  styleUrls: ['./step-additional-info.component.scss'],
  imports: [
    CommonModule,
    SharedModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    AdditionalInfoPetitionerComponent,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule
  ]
})
export class StepAdditionalInfoComponent implements OnInit, OnChanges {
  @Input() user!: User;
  @Input() requestObj: any;
  @Input() controller?: AuthorizerUsers;
  @Input() requestType!: string;
  @Input() loanType?: string;
  @Input() stepper!: MatStepper;
  @Input() campaign?: any;

  @Output() sendRequestEmitter = new EventEmitter<any>();
  @Output() backStepEmitter = new EventEmitter();

  requestResume: any;
  requestTypeEnum = RequestType;
  authorizationInfo?: AuthorizerUsers;
  loanOptions = LoanOptions;
  additionalInfoError = false;
  addDataError = '';
  substitutionVehicle: any;
  substitutionVin: string | undefined;
  substitutionRequestNumber: string | undefined;
  requestCarType: string | undefined;
  landing2 = false;

  checkboxOptionalMap = new Map<string, boolean>();
  isCheckboxOptional = false;
  userTooltip = '';
  specialCompensation = '';
  validationError = false;
  tmaimgKms = 0;
  tmaimgMonths = 0;
  estimatedKms = 0;
  diffMonths = 0;
  minimumMonths = false;
  retribution = '';
  retributionText = '';

  public DeliveryLocation = DeliveryLocation;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private storageService: StorageService,
    public dialog: MatDialog,
    private vehicleService: VehiclesService,
    private checkValidations: CheckValidations
  ) {}

  ngOnInit(): void {
    if (this.user === undefined) {
      this.user = this.storageService.get('config');
    }
    this.checkboxOptionalMap.set('ACR MARTORELL', false);
    this.checkboxOptionalMap.set('BILBAO', true);
    this.checkboxOptionalMap.set('C T MARTORELL', false);
    this.checkboxOptionalMap.set('C. T. S. - MRT', false);
    this.checkboxOptionalMap.set('CATALUNYA MOTOR', false);
    this.checkboxOptionalMap.set('CONNECTED MOBILITY VENT.', false);
    this.checkboxOptionalMap.set('FABR BARCELONA', false);
    this.checkboxOptionalMap.set('FABR MARTORELL', false);
    this.checkboxOptionalMap.set('FABR PRAT', false);
    this.checkboxOptionalMap.set('GEARBOX PRAT', false);
    this.checkboxOptionalMap.set('LA CORUÑA', true);
    this.checkboxOptionalMap.set('MADRID', true);
    this.checkboxOptionalMap.set('MADRID-TORRE CRISTAL', true);
    this.checkboxOptionalMap.set('METROPOLIS LAB BARCELONA', false);
    this.checkboxOptionalMap.set('SEAT COMPONENTES', false);
    this.checkboxOptionalMap.set('SEAT CUPRA, S.A.', false);
    this.checkboxOptionalMap.set('SEVILLA', true);
    this.checkboxOptionalMap.set('VALENCIA', true);
    this.checkboxOptionalMap.set('VALLADOLID', true);

    if (this.user && this.user.workPlace)
      this.isCheckboxOptional =
        this.checkboxOptionalMap.get(this.user.workPlace) || false;

    if (this.requestType === this.requestTypeEnum.loan) {
      this.isCheckboxOptional = false;
    }

    if (!this.isCheckboxOptional) {
      this.form.get('deliveryLocationChecked')?.setValue(true);
    }

    // TODO LIMPIAR SUBSTITUTIONVEHICLE AL CREAR SOLICITUD PARA QUE NO APAREZCA AL INICIAR OTRA SOLICITUD

    this.landing2 = this.storageService.get('landing2') || false;
    this.substitutionVehicle = this.storageService.get('substitutionVehicle');

    this.substitutionVin = this.storageService.get('substitutionVin');
    this.substitutionRequestNumber = this.storageService.get(
      'substitutionRequestNumber'
    );
    this.requestCarType = this.storageService.get('requestCarType');

    if (
      !!this.substitutionVehicle &&
      (this.requestCarType === 'endowmentLeasingEndowment' ||
        this.requestCarType === 'endowmentLeasingLeasing')
    ) {
      this.fetchValidations(this.substitutionVehicle.tmaimg);
    }
    this.userTooltip = `Correo: ${this.user?.email}\n\nTeléfono: ${this.user?.contact?.leasingNumber}\n\nCódigo Postal: ${this.user?.address?.postalCode}`;
    const special = this.storageService.get('specialCompensationLeasing');
    this.specialCompensation = this.stripHtml(special);

    if (!!this.user && this.requestType === this.requestTypeEnum.function) {
      this.vehicleService
        .getVehiclesRetribution(
          this.user.nis,
          !!this.substitutionVin ? this.substitutionVin : null,
          'FUNCTION'
        )
        .subscribe({
          next: (resp) => {
            this.retribution = resp.response;
            return this.retributionTranslation(this.retribution);
          },
          error: () => {
            return (this.retributionText = i18next.t('noData'));
          }
        });
    }
  }

  retributionTranslation(retribution: string): string {
    return retribution === 'PRIMARY'
      ? (this.retributionText = i18next.t('primary'))
      : retribution === 'PRIMARY_ENDOWMENT'
        ? (this.retributionText = i18next.t('primaryEndowment'))
        : (this.retributionText = i18next.t('secondary'));
  }

  stripHtml(html: string): string {
    // Utiliza una expresión regular para eliminar todas las etiquetas HTML
    return html ? html.replace(/<\/?[^>]+(>|$)/g, '') : i18next.t('noData');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['requestObj']) {
      this.requestResume = this.requestObj;
    }
    if (!!changes['controller']) {
      this.authorizationInfo = this.controller;
    }
  }

  form = this.fb.group({
    comments: [''],
    moreThanOneVehicle: [false],
    emailCheck: [false],
    leasing: [false],
    email: [''],
    phone: [''],
    estimatedKms: [, [this.integerValidator()]],
    deliveryLocationChecked: [false]
  });

  integerValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return null;
      }

      const strValue = String(value);
      if (strValue.includes('.') || strValue.includes(',')) {
        return { decimalNotAllowed: true };
      }
      return null;
    };
  }

  onDataChange(data: { email: string; phone: string }): void {
    this.form.patchValue({ email: data.email, phone: data.phone });
  }

  onAdditionalDataError(invalid: boolean) {
    this.additionalInfoError = invalid;
    this.addDataError = invalid
      ? 'Error en el apartado de información adicional'
      : '';
  }

  /*checkLoanType() {
     return (
      this.form.value.loanType === LoanOptions.LD || this.moreThanOneVehicle
    );
  }*/

  getDifferenceInFullMonths(date1: Date, date2: Date): number {
    const [start, end] = date1 < date2 ? [date1, date2] : [date2, date1];

    const yearDiff = end.getFullYear() - start.getFullYear();
    const monthDiff = end.getMonth() - start.getMonth();
    const dayDiff = end.getDate() - start.getDate();

    let totalMonths = yearDiff * 12 + monthDiff;

    if (dayDiff < 0) {
      totalMonths--;
    }

    if (yearDiff > 0 && monthDiff === 0 && dayDiff < 0) {
      totalMonths = yearDiff * 12 - 1;
    }

    return totalMonths;
  }

  sendRequest() {
    const checkMartorell = this.isCheckboxOptional
      ? this.form.get('deliveryLocationChecked')?.value
      : false;
    if (this.requestType === 'CAMPAIGN' && this.substitutionVin) {
      const deliveryDate = new Date(this.substitutionVehicle?.deliveryDate);
      const today = new Date();
      this.diffMonths = this.getDifferenceInFullMonths(deliveryDate, today);
      this.minimumMonths = this.diffMonths > this.campaign.vehicleMonths;
      if (
        !!this.campaign.vehicleKms &&
        this.campaign.vehicleKms > this.form.value.estimatedKms! &&
        !this.minimumMonths
      ) {
        this.dialog.open(FeedbackModalComponent, {
          width: '400px',
          data: {
            text: i18next.t('notRequest'),
            close: true,
            theme: 'ligth'
          }
        });
      } else {
        this.sendRequestEmitter.emit({
          ...this.form.value,
          requestCarType: this.requestCarType,
          substitutionVin: this.substitutionVin,
          substitutionRequestNumber: this.substitutionRequestNumber
        });
      }
    } else {
      this.sendRequestEmitter.emit({
        ...this.form.value,
        requestCarType: this.requestCarType,
        substitutionVin: this.substitutionVin,
        substitutionRequestNumber: this.substitutionRequestNumber,
        retribution: this.retribution,
        checkMartorell: checkMartorell
      });
    }
  }

  backStep() {
    this.stepper?.selectedIndex === 0
      ? this.landing2
        ? this.router.navigateByUrl('/landing-leasing')
        : this.router.navigateByUrl('/menu')
      : this.backStepEmitter.emit();
  }

  isButtonDisabled() {
    if (this.requestType === this.requestTypeEnum.leasing) {
      if (this.substitutionVehicle && !this.form.get('estimatedKms')?.value)
        return true;
      return !(
        this.form.get('emailCheck')?.value && this.form.get('leasing')?.value
      );
    } else if (
      this.requestType === this.requestTypeEnum.function &&
      !this.retribution
    ) {
      return true;
    } else if (this.substitutionVehicle) {
      return !this.form.get('estimatedKms')?.value;
    } else {
      return false;
    }
  }

  getButtonStyle(): string {
    return this.isButtonDisabled() ||
      this.additionalInfoError ||
      this.form.get('estimatedKms')?.hasError('decimalNotAllowed') ||
      this.validationError
      ? 'background-color: #565554'
      : 'background-color: #2c2a29';
  }

  changeEstimatedKms() {
    if (this.form.controls['estimatedKms'].valid) {
      this.validationError = false;
      const estimatedKms = this.form.get('estimatedKms')?.value || 0;
      if (
        this.requestCarType === 'endowmentLeasingEndowment' ||
        this.requestCarType === 'endowmentLeasingLeasing'
      ) {
        this.validationError = this.checkValidations.checkValidations(
          estimatedKms,
          this.tmaimgKms,
          this.substitutionVehicle.deliveryDate,
          this.tmaimgMonths
        );
      }
    }
  }

  fetchValidations(tmaimg: string) {
    const requestTypeDotArr = this.storageService.get('requestCarType');

    if (
      this.requestType !== this.requestTypeEnum.innerRoute &&
      this.requestType !== this.requestTypeEnum.campaigns
    ) {
      this.vehicleService
        .getValidations(
          tmaimg,
          requestTypeDotArr === 'endowmentLeasingEndowment'
            ? 'ENDOWMENT'
            : this.requestType
        )
        .subscribe({
          next: (data) => {
            this.validationError = false;
            this.tmaimgKms = data.kms || 0;
            this.tmaimgMonths = data.months || 0;
          },
          error: (error) => {
            console.error('Error al obtener validaciones:', error);
          }
        });
    }
  }
}
